import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BRAND } from '../brand';

const DynamicManifest = () => {
  const location = useLocation();

  useEffect(() => {
    const manifestLink = document.querySelector('link[rel="manifest"]');
    const themeColor = document.querySelector('meta[name="theme-color"]');
    const appleTitleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');

    if (!manifestLink) return;

    if (location.pathname.startsWith('/admin')) {
      manifestLink.href = '/manifest-admin.json';
      document.title = `${BRAND.name} Admin`;
      if (themeColor) themeColor.content = BRAND.theme.primaryDark || BRAND.theme.primary;
      if (appleTitleMeta) appleTitleMeta.content = `${BRAND.name} Admin`;
    } else if (
      location.pathname.startsWith('/dashboard') ||
      location.pathname.startsWith('/send') ||
      location.pathname.startsWith('/transactions') ||
      location.pathname.startsWith('/recipients') ||
      location.pathname.startsWith('/convert')
    ) {
      manifestLink.href = '/manifest-client.json';
      document.title = `${BRAND.name} - Mi Cuenta`;
      if (themeColor) themeColor.content = BRAND.theme.primary;
      if (appleTitleMeta) appleTitleMeta.content = `${BRAND.name}`;
    } else {
      manifestLink.href = '/manifest.json';
      document.title = `${BRAND.name} · ${BRAND.tagline}`;
      if (themeColor) themeColor.content = BRAND.theme.primary;
      if (appleTitleMeta) appleTitleMeta.content = BRAND.name;
    }
  }, [location.pathname]);

  return null;
};

export default DynamicManifest;
